import * as React from 'react';
import { find as _find } from 'lodash';
import { Modal } from 'reactstrap';
import { setTimeout } from 'timers';
import { UserModel } from 'franke-trough-dependencies';

export interface UserListScheduleModalProps {
  user: UserModel;
  drilledConfirm: (user: UserModel, dateFrom: string, dateUntil: string) => void;
  drilledClose: () => void;
  schedule?: {dateFrom: string | null, dateUntil: string | null};
}

export interface UserListScheduleModalState {
  dateFrom: string;
  dateUntil: string;
  isOpen: boolean; 
}

export class UserListScheduleModal extends React.Component<UserListScheduleModalProps, UserListScheduleModalState> {
  constructor(props: UserListScheduleModalProps) {
    super(props);
    this.state = {
      dateFrom: '',
      dateUntil: '',
      isOpen: false,
    };
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.setState({
      isOpen: true,
      dateFrom: this.props.schedule && this.props.schedule.dateFrom && this.props.schedule.dateFrom.split('T')[0] || '',
      dateUntil: this.props.schedule && this.props.schedule.dateUntil && this.props.schedule.dateUntil.split('T')[0] || ''
    });
  }

  componentDidUpdate() {
    if (!this.state.isOpen) {
      this.setState({
        isOpen: true,
      });
    }
  }

  public render() {
    const user = this.props.user;

    return (
      <Modal 
        isOpen={this.state.isOpen} 
        backdrop={true}
        toggle={this.closeModal}
        className="modal-dialog--small user-delete-modal"
      >
        <div className="modal-inner d-flex justify-content-center align-items-center vh-100">
          {user && (
            <form onSubmit={this.handleConfirm}>
              <h3 className="modal-heading">Set a temporary substitute</h3>
              <div className="modal-body">
                After the set time period has expired, the connection  to the following user (and his or her own connections) is removed: <br />
                <b>{user.email}</b>
              </div>
              <div className="mb-1">
                Valid period from:
              </div>
              <div className="modal-input">
                <div>
                  <input type="date" name="date-from" value={this.state.dateFrom} required
                    onChange={e => this.setState({...this.state, dateFrom: e.target.value})}/>
                </div>
                <div>
                  to
                </div>
                <div>
                  <input type="date" name="date-until" value={this.state.dateUntil}  
                    onChange={e => this.setState({...this.state, dateUntil: e.target.value})}/>
                </div>
              </div>
              <div className="modal-actions text-center">
                <button 
                  className="btn btn-secondary w-100"
                  type="submit"
                >
                  Save
                </button>
                <button 
                  className="btn btn-light btn-bordered w-100"
                  onClick={this.closeModal}
                >
                  Cancel
                </button>
              </div>
            </form>
          )}
        </div>
      </Modal>
    );
  }

  private closeModal(): void {
    this.setState({
      isOpen: false,
    });
    setTimeout(() => this.props.drilledClose(), 151);
  }

  handleConfirm = (event: any) => {
    event.preventDefault();

    if (!this.props.drilledConfirm) { return; }

    const user = this.props.user;

    this.props.drilledConfirm(user, this.state.dateFrom, this.state.dateUntil);
    this.closeModal();
  }
}

// export const UserListScheduleModal = connect((state: GlobalPrivateState) => ({
// }))(UserListScheduleModalPartial as any);

export default UserListScheduleModal;